<div class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 p-4">
  <div class="w-full max-w-sm rounded-lg bg-white shadow-lg">
    <div class="flex items-center justify-between border-b border-slate-200 px-6 py-4">
      <h3 class="text-base font-semibold text-slate-900">New Customer</h3>
      <button
        class="text-slate-400 hover:text-slate-600"
        type="button"
        (click)="close()"
        aria-label="Close"
      >
        <span class="material-icons text-base">close</span>
      </button>
    </div>

    <form class="space-y-4 px-6 py-5" [formGroup]="form" (submit)="submit($event)">
      <div class="space-y-1">
        <label class="flex items-center gap-4 text-sm text-slate-600">
          <span class="w-20">Name</span>
          <input
            type="text"
            class="w-full rounded-md border border-slate-200 px-3 py-2 text-sm text-slate-700 focus:border-blue-400 focus:outline-none"
            formControlName="name"
            required
          />
        </label>
        @if (form.controls.name.invalid && (form.controls.name.touched || triedSubmit)) {
          <p class="pl-24 text-xs text-red-600">Name is required.</p>
        }
      </div>

      <div class="space-y-1">
        <label class="flex items-center gap-4 text-sm text-slate-600">
          <span class="w-20">Voucher</span>
          <input
            type="text"
            class="w-full rounded-md border border-slate-200 px-3 py-2 text-sm text-slate-700 focus:border-blue-400 focus:outline-none"
            formControlName="voucher"
            required
          />
        </label>
        @if (form.controls.voucher.invalid && (form.controls.voucher.touched || triedSubmit)) {
          <p class="pl-24 text-xs text-red-600">Voucher is required.</p>
        }
      </div>

      <div class="space-y-1">
        <label class="flex items-center gap-4 text-sm text-slate-600">
          <span class="w-20">Uses</span>
          <input
            type="number"
            min="0"
            class="w-full rounded-md border border-slate-200 px-3 py-2 text-sm text-slate-700 focus:border-blue-400 focus:outline-none"
            formControlName="uses"
            required
          />
        </label>
        @if (form.controls.uses.invalid && (form.controls.uses.touched || triedSubmit)) {
          @if (form.controls.uses.hasError('required')) {
            <p class="pl-24 text-xs text-red-600">Uses is required.</p>
          } @else if (form.controls.uses.hasError('min')) {
            <p class="pl-24 text-xs text-red-600">Uses must be 0 or more.</p>
          }
        }
      </div>

      <div class="pt-1">
        <button
          class="rounded-md bg-blue-600 px-5 py-2 text-sm font-semibold text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-70"
          type="submit"
          [disabled]="form.invalid || isSaving"
        >
          @if (isSaving) {
            Saving...
          } @else {
            Save
          }
        </button>
      </div>
    </form>
  </div>
</div>
